export default {
  locale: 'zh-CN',
  // common
  'common.empty': '暂无数据',
  'common.loading': '加载中...',
  // pagination
  'pagination.goto': '前往',
  'pagination.page': '页',
  'pagination.countPerPage': '条/页',
  'pagination.total': '共 {0} 条',
  // upload
  'upload.buttonLabel': '点击上传',
  'upload.drag': '点击或拖拽文件到此处上传',
  'upload.dragHover': '释放文件并开始上传',
  'upload.retry': '点击重试',
  'upload.delete': '删除',
  'upload.preview': '预览',
  'upload.edit': '编辑',
  // select
  'select.cancel': '取消',
  'select.confirm': '确定',
  // input
  'input.limit': '<b>{0}</b>/{1}',
};
